import InputController from './input-controller';

export { InputController };
